import React, { useState, useEffect } from "react";
import { NavLink, useHistory, useParams, useLocation } from "react-router-dom";
import queryString from "query-string";

import config from "config/common";
import lib from "lib/commons";

import Sidebar from "./Sidebar";
import ModalHistory from "components/ModalHistory";

const Header = ({
  lng,
  user: {
    user: {
      nickname = "",
      id: userId = null,
      uid = null,
      total_spin_times: totalSpinNum = 0,
      vote_history: voteHistory = [],
    } = {},
    matches = [],
    userHistory = [],
    eventStarted,
    isGettingHistory,
    popupGuide = "",
    bannerGift = "",
  } = {},

  getHistory,
}) => {
  const history = useHistory();
  const [modalStatus, setModalStatus] = useState(false);
  const closeModal = () => setModalStatus(false);

  return (
    <>
      <div id="header">
        <div className="top-bar">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-3">
                <a href="https://fconline.garena.vn" className="logo">
                  <img src="/images/logo.png" alt="" />
                </a>
              </div>
              <div className="col-6">
                <a href="#" className="menu-link">
                  <span>Trang chủ</span>
                </a>
                <a
                  href="#"
                  className="menu-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setModalStatus(true);
                  }}
                >
                  <span>Lịch sử</span>
                </a>
                <a
                  href="#"
                  className="menu-link"
                  onClick={(e) => {
                    e.preventDefault();
                    lib.showImage(popupGuide);
                  }}
                >
                  <span>Hướng dẫn</span>
                </a>
              </div>
              <div className="col-3 text-center">
                {/* {!userId ? (
                  <a
                    href="/user/login"
                    className="btn-login"
                    onClick={(e) => {
                      if (!eventStarted) {
                        e.preventDefault();
                        lib.showMessage(config.demoMsg);
                        return false;
                      }
                    }}
                  >
                    Đăng nhập
                  </a>
                ) : (
                  <>
                    <span className="user-info">
                      HLV <strong className="nickname">{'Slim Shady'}</strong>
                    </span>
                  </>
                )} */}
                {!!userId && (
                  <span className="user-info">
                    HLV<span className="nickname">{nickname}</span>
                  </span>
                )}
              </div>
            </div>
          </div>
          {!userId ? (
            // <a href="/user/login" className="header-btn">
            //   <span>
            //     <img src="/images/icon-login.png" alt="" />
            //   </span>
            // </a>
            <a
              href="/user/login"
              className="header-btn"
              onClick={(e) => {
                if (!eventStarted) {
                  e.preventDefault();
                  lib.showMessage(config.demoMsg);
                  return false;
                }
              }}
            >
              <span>Đăng nhập</span>
            </a>
          ) : (
            !lib.isInGame() && (
              // <a href="/user/logout" className="header-btn">
              //   <span>
              //     <img src="/images/icon-logout.png" alt="" />
              //   </span>
              // </a>
              <a href="/user/logout" className="header-btn">
                <span>Đăng xuất</span>
              </a>
            )
          )}
        </div>
      </div>
      {modalStatus && (
        <ModalHistory
          userHistory={userHistory}
          isGettingHistory={isGettingHistory}
          getHistory={getHistory}
          voteHistory={voteHistory}
          matches={matches}
          modalStatus={modalStatus}
          closeModal={closeModal}
        />
      )}
    </>
  );
};

export default Header;
